import RadioGroup from "designSystem/components/radio/RadioGroup";
import { FlexColumn, FormField, SingleSelect, Text } from "designSystem/index";
import { black } from "designSystem/styles/color";
import { observer } from "mobx-react-lite";
import React from "react";
import { useSnapshotTemplateStore } from "../SnapshotTemplateStore";
import { REQUIRED_LABEL } from "../snapshotUtils";

const ImageSettings = observer(() => {
	const store = useSnapshotTemplateStore();
	const { 
		imageCount,
		imageFormat,
		imageRatio,
		imageTypeIsTurntable,
		imageCountOptions,
		imageFormatOptions, 
		imageRatioOptions,
		setImageCount,
		setImageFormat,
		setImageRatio,
	} = store;

	return (
		<FlexColumn
			sx={{ 
				height:"auto",
			}}
		>
			<FormField
				control={(
					<RadioGroup							
						onChange={setImageFormat}
						options={imageFormatOptions}
						value={imageFormat}
					/>
				)}
				fullWidth
				label={<Text bold res="ImageFormat" />}
				labelPlacement="top"
				required
				sx={{
					...REQUIRED_LABEL,
					width: "fit-content",
					alignItems: "flex-start",
					"& .MuiTypography-root":{
						color: black[100],
					},
				}}
			/>
			<FormField
				control={(
					<SingleSelect
						onChange={setImageRatio}
						options={imageRatioOptions}
						placeHolderRes="SelectImageRatio"
						value={imageRatio}
					/>
				)}
				fullWidth
				label={<Text bold res="ImageRatio" />}
				labelPlacement="top"
				required
				sx={REQUIRED_LABEL}
			/>
			{
				imageTypeIsTurntable && (
					<FormField
						control={(
							<SingleSelect
								onChange={setImageCount}
								options={imageCountOptions}
								placeHolderRes="ImageCount"
								value={imageCount}
							/>
						)}
						fullWidth
						label={<Text bold res="ImageCount" />}
						labelPlacement="top"
						required
						sx={REQUIRED_LABEL}
					/>
				)
			}
		</FlexColumn>
	);
});

export default ImageSettings;